import { message, notification } from "antd";
import { useSelector } from "react-redux";
import { pageRoutes } from "../Routing/Routing";
import Services from "../Services";
import { getImageUrl } from "./getImageUrl";
import { showSnackBar } from "./showSnackBar";

const {
    users = null,
} = Services;

export const documentSubmit = async (setposting, dataObj, formId, specificConfiguration, access, history) => {
    if (!access) {
        message.info("Please login in order to submit documents.")
        history.push(pageRoutes.applicant[0].path)
        return
    }
    try {

        setposting(true);

        if (dataObj) {
            let data = dataObj

            const nullCheck = Object.values(data)
                .reduce((total, accumulator) => total || !accumulator, false);

            if (nullCheck) {
                setposting(false);
                showSnackBar("Kindly fill in all fields!");
                return
            }
        }

        let contentURLs = await getImageUrl('capture')

        if (specificConfiguration?.length > 0) {
            for (let i = 0; i < specificConfiguration?.length; i++) {
                contentURLs[specificConfiguration[i]?.index] = { url: contentURLs[specificConfiguration[i]?.index]?.url, height: contentURLs[specificConfiguration[i]?.index]?.height - specificConfiguration[i]?.height }
            }
        }
        window.scrollTo(0, 0)
        await users.submitForm({
            image: contentURLs,
            form: formId,
        });

        const step3FormPosted = new BroadcastChannel('step3form_posted');
        step3FormPosted.postMessage({ topic: 'form-updated', message: {} })
        showSnackBar('Form has been submitted!');
        setposting(false);
        window.self.close();


    } catch (exc) {

        setposting(false);
        return showSnackBar(exc.message)
    }
}